module.exports = __webpack_public_path__ + "static/img/topsnap.31244f01.svg";